import React, { PureComponent } from 'react'
import { matchPath, Route, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Header from './Header'
import TopBar from './TopBar'
import { Info } from '@mui/icons-material';
import classNames from 'classnames';
import Footer from './Footer'
import DrupalModal from './DrupalModal'
import Filter from './Filter'
import { findCohort } from '../../services/reservoir'
import Search from './Search'
import HamburgerMenu from './HamburgerMenu'
import MyCourseFooter from './MyCourseFooter'
import { getConfiguration } from '../../helpers/configuration'

const mapStateToProps = ({ courses: { selectedCourseCode, data }, course: { selectedCourse }, currentUser }) => {
  return {
    admissionCategory: selectedCourse.admissionCategory,
    courseCode: selectedCourseCode,
    userRole: currentUser.data['role']
  }
}

class Layout extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      drawerOpen: false,
      offers: [],
      showInfoModal: false,
      cohortTax: ''
    }
  }

  componentDidMount() {
    this.loadCohort()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.admissionCategory !== this.props.admissionCategory) {
      this.loadCohort()
    }
  }

  loadCohort = () => {
    findCohort(this.props.admissionCategory).then(item => {
      //console.log('item %o', this.cleanLabel(item.attributes.name) )
      this.setState({
        cohortTax: item ? this.cleanLabel(item.attributes.name) : ''
      })
    })
  }

  cleanLabel = taxName => {
    return taxName.split(' ').join('')
  }

  handleInfoCloseModal = () => {
    this.setState({
      showInfoModal: false
    })
  }

  getPageKey = () => {
    const pageKey = this.props.location.pathname.replace(getConfiguration('baseUrl') + '/', '').split('/')[0]
    if (pageKey) {
      return pageKey
    }
    return 'home'
  }

  isSecondaryPage = () => {
    const pathname = this.props.location.pathname

    return matchPath(pathname, { path: `${getConfiguration('baseUrl')}/resources` }) || matchPath(pathname, { path: `${getConfiguration('baseUrl')}/finances` })
  }

  isMyResourcesPage = () => {
    const pathname = this.props.location.pathname

    return matchPath(pathname, { path: `${getConfiguration('baseUrl')}/resources` })
  }

  render() {
    const shouldShowTopBar = this.props.userRole == 'EDITOR' || this.props.userRole == 'REVIEWER'

    const showTopBarPreviewOptions = this.props.userRole == 'EDITOR'

    return (
      <div
        id="app"
        className={classNames(
          `page-${this.getPageKey()}`,
          { [`cohort--${this.state.cohortTax}`]: this.state.cohortTax },
          { 'secondary-page': this.isSecondaryPage() },
          { 'secondary-page--lg': this.isMyResourcesPage() },
          { [`secondary-page--${this.getPageKey()}`]: this.isSecondaryPage() }
        )}
      >
        {shouldShowTopBar ? <TopBar showPreviewOptions={showTopBarPreviewOptions} /> : ''}

        <Header
          onHamburgerClick={() =>
            this.setState({
              drawerOpen: true
            })
          }
        />
        <Route
          path={getConfiguration('baseUrl') + '/enrolments'}
          render={() => (
            <div className="filter-container filter-container--grey">
              <Info color='secondary' sx={{ fontSize: 30}}/>{' '}
              <button className="btn-link" onClick={() => this.setState({ showInfoModal: true })}>
                Find my Course Plan
              </button>
            </div>
          )}
        />

        <Route exact={true} path={getConfiguration('baseUrl') + '/'} component={Filter} />

        <main id="content" className="container">
          {this.props.children}
        </main>

        <Search />

        <DrupalModal className="modal-lg" isOpen={this.state.showInfoModal} handleCloseModal={this.handleInfoCloseModal} slug="unit-information" />

        <Route path={getConfiguration('baseUrl') + '/enrolments'} component={MyCourseFooter} />

        <Footer />

        <HamburgerMenu onClose={() => this.setState({ drawerOpen: false })} open={this.state.drawerOpen} />
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps)(Layout))
